import './help.css'

import React from 'react'
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { useModal } from '@/components/modal/Modal'


interface HelpPopupBodyProps {
    translates: Translates
    helpKey: string
    onClose: () => void
}


export function HelpPopupButton({ helpKey, translates }: { helpKey: string, translates: Translates }) {
    const { openModal } = useModal()
    let open = () => openModal(({ onClose }: { onClose: () => void }) => {
        return HelpPopupBody({ onClose, helpKey, translates })
    })
    return <div className='help-popup-button' onClick={() => openModal(({ onClose }: { onClose: () => void }) => {
        return HelpPopupBody({ helpKey, onClose, translates })
    })}>
        <i className='svgfont-help' />
    </div>
}

export function HelpPopupBody({ translates, helpKey, onClose }: HelpPopupBodyProps) {
    return (
        <div className='help-popup-body'>
            <h3>{translates.for(helpKey + '.title')}</h3>
            <div className='help-popup-content'>
                {translates.for(helpKey + '.content')}
            </div>
        </div>
    )
}
